import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesComponent } from './pages.component';
import { AppSharedModule } from '../shared/appshared.module';



import { PagesRoutingModule } from './pages-routing.module';
//import { TreeModule } from 'angular2-tree-component';
import { TabViewModule } from 'primeng/primeng';
import { DataTableModule, SharedModule } from 'primeng/primeng';
import { PageViewComponent } from './page-view/page-view.component';
import { BreadcrumbComponent, Breadcrumb, TreeBreadcrumb } from '../shared/custom/breadcrumb/breadcrumb.component';
import { BreadcrumbModule } from '../shared/custom/breadcrumb/breadcrumb.module';

@NgModule({
    imports: [
        CommonModule,
        AppSharedModule,
        PagesRoutingModule,
        //TreeModule,
        TabViewModule,
        DataTableModule,
        SharedModule,
        BreadcrumbModule
    ],
    declarations: [PagesComponent, PageViewComponent],
    exports: [BreadcrumbModule, BreadcrumbComponent]
})
export class PagesModule { }




// WEBPACK FOOTER //
// ./src/app/pages/pages.module.ts